import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import BrandsManagement from '../components/BrandsManagement';

const BrandsAdmin = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b sticky top-0 z-10">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="outline"
                onClick={() => navigate('/admin/dashboard')}
                className="flex items-center gap-2"
              >
                <ArrowLeft size={18} />
                Torna al Dashboard
              </Button>
              <div>
                <h1 className="text-2xl font-bold text-slate-800">Gestione Marchi</h1>
                <p className="text-sm text-slate-600">Amministra i marchi e le aziende partner</p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="text-right">
                <p className="text-sm font-medium text-slate-700">{user?.email || 'Admin'}</p>
                <p className="text-xs text-slate-500 uppercase">{user?.role || 'ADMIN'}</p>
              </div>
              <Button
                variant="outline"
                onClick={handleLogout}
                className="flex items-center gap-2 text-red-600 hover:bg-red-50"
              >
                <LogOut size={18} />
                Esci
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        <BrandsManagement />
      </main>
    </div>
  );
};

export default BrandsAdmin;
